module.exports = __webpack_public_path__ + "static/img/meinuo.d9da09d3.png";